import React from 'react';
import { useSkin, useSkinSettings } from './SkinContext';
import { getBeijingPeriod } from '../utils/skyTheme';

// An open journal cradled by a small nest, in the site's three quiet colours.
export default function BrandMark({ skin: skinProp, period: periodProp }) {
  const context = useSkin();
  const settings = useSkinSettings();
  const skin = skinProp || (typeof context === 'string' ? context : context?.skin) || 'regular';
  const period = periodProp || settings?.period || (typeof context === 'object' && context?.period) || getBeijingPeriod();

  if (skin === 'orbital') return <svg className="brand-mark brand-mark--orbital" viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false">
    <circle cx="24" cy="24" r="19" fill="#101c3b" stroke="#9db9d2" strokeWidth="1.15" />
    <circle cx="24" cy="24" r="15" stroke="#637d9d" strokeWidth=".6" strokeDasharray="2 3" />
    <ellipse cx="24" cy="24" rx="19" ry="8" transform="rotate(-31 24 24)" stroke="#c2ddec" strokeWidth="1.4" />
    <circle cx="24" cy="24" r="7" fill="#6089a6" stroke="#d4e7e8" strokeWidth="1.3" />
    <path d="M20 21.5c1.5-2 3-2.5 5-2m-7 7c3 4 7 4.5 11 1.5" stroke="#d8e9ec" strokeWidth="1.2" strokeLinecap="round" />
    <path d="m36 10 1 2.8 2.8 1L37 15.9l-1 2.8-1-2.8-2.8-1 2.8-1L36 10Z" fill="#efd7a6" />
    <circle cx="9" cy="32" r="1.5" fill="#e2c68d" />
  </svg>;

  if (skin === 'terminal') return <svg className="brand-mark brand-mark--terminal" viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false">
    <rect x="4.5" y="7.5" width="39" height="33" rx="5" fill="#f6f8f5" stroke="#66716f" strokeWidth="1.4" />
    <path d="M9.5 8h29a4.5 4.5 0 0 1 4.5 4.5V19H5v-6.5A4.5 4.5 0 0 1 9.5 8Z" fill="#454d50" />
    <circle cx="11" cy="13.5" r="1.7" fill="#c57770" /><circle cx="16.5" cy="13.5" r="1.7" fill="#cfaa6f" /><circle cx="22" cy="13.5" r="1.7" fill="#7eaa87" />
    <path d="m12 26 5 4-5 4m9 0h13" stroke="#607f69" strokeWidth="2.4" strokeLinecap="square" strokeLinejoin="miter" />
    <path d="M35 24v10" stroke="#a8b6ac" strokeWidth="1.5" />
  </svg>;

  if (skin === 'atelier') return <svg className="brand-mark brand-mark--atelier" viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false">
    <path d="M11 5c8-1 18-1 26 0v36l-13-8-13 8V5Z" fill="#f8f2e7" stroke="#967151" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M15 9c6-1 12-1 18 0M15 13c6-.8 12-.8 18 0" stroke="#c8aa89" strokeWidth=".8" strokeLinecap="round" />
    <path d="M17 18c4-2 8-2 13 0M16 24c5-2.5 10-2.5 16 0M17 29c4-1.5 8-1.5 12 0" stroke="#624b42" strokeWidth="1.35" strokeLinecap="round" />
    <path d="M23 17c-.5 5 0 10 1 15" stroke="#a87c5f" strokeWidth=".8" />
    <circle cx="35" cy="34" r="5" fill="#b6755b" stroke="#754c3e" strokeWidth=".9" />
    <path d="m32.5 34 2 2 3-4" stroke="#fff1db" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
  </svg>;

  if (skin === 'dynamic') return <svg className="brand-mark brand-mark--dynamic" viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false">
    <circle cx="33" cy="14" r="6" fill={period === 'night' ? '#e5eaf4' : period === 'dusk' ? '#edac77' : '#eedaa6'} />
    {period === 'night' && <circle cx="35.5" cy="11" r="5" fill="#435c86" />}
    <path d="M11 27c-5-1-8 4-5 8 1 2 3 2 5 2h26c6 0 8-7 3-10-2-1-3-1-5 0-2-6-10-7-14-2-3-3-8-3-10 2Z" fill={period === 'night' ? '#d5dff1' : '#fffdf8'} fillOpacity=".92" stroke={period === 'night' ? '#b9cbe7' : '#9fbbd5'} strokeWidth="1.4" />
    <path d="M14 34c7 1 14 1 21 0M16 29c2-3 5-4 8-3" stroke="#b5cce2" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M14 40c7 2 16 2 23-1" stroke={period === 'dusk' ? '#d99272' : '#9bb7ce'} strokeWidth="1.4" strokeLinecap="round" />
  </svg>;

  return <svg className="brand-mark" viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false">
    <path d="M7 32c8 8 26 8 34 0" stroke="#d8aaa2" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M11 36c7 6 19 6 26 0" stroke="#e1b795" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M24 31c-5-4-11-5-17-3V12c7-1 13 1 17 5 4-4 10-6 17-5v16c-6-2-12-1-17 3Z" fill="#fffdf8" fillOpacity=".7" stroke="#829abb" strokeWidth="1.65" strokeLinejoin="round" />
    <path d="M24 17v14M12 18c3 0 5 1 7 2m-7 3 7 2m10-5 7-2m-7 7 7-2" stroke="#a9b9d1" strokeWidth="1.3" strokeLinecap="round" />
    <circle cx="24" cy="8" r="3" fill="#e3bd99" />
  </svg>;
}
